import { Customer } from "../customer/Customer"
import { CustomerQuotePartDetails } from "./CustomerQuotePartDetails"
import { CustomerQuoteServiceDetails } from "./CustomerQuoteServiceDetails"

export class CustomerQuoteDetails {
  id: number
  approvedDate?: string
  buildTypeName: string
  cartridgeName: string
  customer: Customer
  customerSuppliedParts: string
  expirationDate?: string
  parts: CustomerQuotePartDetails[]
  partsDiscountPercentage: number
  services: CustomerQuoteServiceDetails[]
  servicesDiscountPercentage: number
  total: number
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, approvedDate: string|undefined, buildTypeName: string, cartridgeName: string, customer: Customer, customerSuppliedParts: string, expirationDate: string|undefined, partsJson: any, partsDiscountPercentage: number, servicesJson: any, servicesDiscountPercentage: number, total: number) {
    this.id = id
    this.approvedDate = approvedDate
    this.buildTypeName = buildTypeName
    this.cartridgeName = cartridgeName
    this.customer = customer
    this.customerSuppliedParts = customerSuppliedParts
    this.expirationDate = expirationDate

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.parts = partsJson ? partsJson.map((o: any) => new CustomerQuotePartDetails(o.displayOrder, o.name, o.notes, o.price, o.status)) : []

    this.partsDiscountPercentage = partsDiscountPercentage

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.services = servicesJson ? servicesJson.map((o: any) => new CustomerQuoteServiceDetails(o.description, o.name, o.notes, o.price, o.serviceFieldValues)) : []

    this.servicesDiscountPercentage = servicesDiscountPercentage

    this.total = total
  }
}
